import {useCallback, FC, Dispatch} from 'react';
import Spinner from '../../common/Spinner';
import 'simplebar/dist/simplebar.min.css';
import {
  getSubprocessPopupMessage,
  Subprocess,
  ProcessActions,
  getProcessActionsPopupMessage
} from '../../../constants/constants';
import RunningProcessesElement from './RunningProcessesElement';
import {useTranslation} from 'react-i18next';
import {RunningProcessesProps} from '../../../constants/types';
import {SubprocessPopupData, ProcessFilter, ProcessActionPopupData} from '../types';
import {AlertSettingsProps} from '../../settings/alert_alarm/types';

type RunningProcessesListProps = {
  processesData: RunningProcessesProps,
  setSubprocessPopupData: Dispatch<SubprocessPopupData>,
  setProcessActionsPopupData: Dispatch<ProcessActionPopupData>,
  isLoading: boolean,
  error: string,
  subProcessesData: string[],
  setError: Dispatch<string>,
  processAlertData: Nullable<AlertSettingsProps>,
  filterState: Nullable<ProcessFilter>,
  currentUserId: Nullable<number>,
  hasProcessClaimButton: boolean;
}

export const RunningProcessesList: FC<RunningProcessesListProps> = ({
  processesData,
  setSubprocessPopupData,
  setProcessActionsPopupData,
  isLoading,
  error,
  subProcessesData,
  setError,
  processAlertData,
  filterState,
  currentUserId,
  hasProcessClaimButton
}) => {
  const {t} = useTranslation('processes');

  const handleShowSubprocessPopup = useCallback((
      id: number,
      subProcessType: Subprocess,
      name: string,
      patientName: string
  ) => {
    const message = getSubprocessPopupMessage(subProcessType, name);
    setSubprocessPopupData({id, type: subProcessType, message, patientName});
  }, []);

  const handleShowProcessActionsPopup = useCallback((
      id: number,
      processActionsType: ProcessActions,
      confirmBtnLabel: string,
      assigneeId: number
  ) => {
    const message = getProcessActionsPopupMessage(processActionsType);
    setProcessActionsPopupData(
        {
          id,
          type: processActionsType,
          message,
          confirmBtn: confirmBtnLabel,
          assigneeId
        }
    );
  }, []);

  if (isLoading || !processesData) {
    return <Spinner loadingText={t('loadingText.processInstances')} />;
  }

  return (
    <div className="running-processes-wrapper">
      {!processesData.length && !error ?
        <div className="empty-table-msg">{t('noAnyRunningProcMsg')}</div> :
          processesData.map((data) =>
            (
              <RunningProcessesElement
                key={`process_element_${data.id}`}
                data={data}
                options={subProcessesData}
                setError={setError}
                handleShowSubprocessPopup={handleShowSubprocessPopup}
                handleShowProcessActionsPopup={handleShowProcessActionsPopup}
                processAlertData={processAlertData}
                filter={filterState}
                currentUserId={currentUserId}
                hasProcessClaimButton={hasProcessClaimButton}
              />
            )
          )}
    </div>
  );
};

export default RunningProcessesList;
